import { useUserAccount } from "@/hooks/useUserAccount";
import { ProfileSection } from "./ProfileSection";
import { CompanyVerificationChip } from "./CompanyVerificationChip";
import { CompanyVerificationNotice } from "./CompanyVerificationNotice";
import { DotSeparator } from "./DotSeparator";

export const ProfileCompanySection = () => {
    const { data: account } = useUserAccount();
    const company = account?.company;

    if (!company) return null;

    return (
        <ProfileSection title="Company">
            <div className="flex flex-col">
                <div className="flex flex-wrap items-center gap-3">
                    <div className="text-lg font-medium text-cm-p-text-primary">{company.name}</div>
                    <CompanyVerificationChip status={company.fmcsaVerification.status} />
                </div>
                <div className="flex items-center gap-4 text-xs text-cm-p-text-secondary">
                    {company.mcNumber && (
                        <>
                            <span>MC-{company.mcNumber}</span>
                            <DotSeparator />
                        </>
                    )}
                    <span>DOT-{company.dotNumber}</span>
                </div>
            </div>
            <CompanyVerificationNotice company={company} />
        </ProfileSection>
    );
};
